import { Avatar, Division, Flex, Skeleton } from "@ir/ui";
import React from "react";

const MessageSkeleton = ({ side, className }: { side: "left" | "right", className?: string }) => (
  <Flex className={`msg ${side}-msg mt-4 ${className}`}>
    <Flex className="msg-avatar">
      <Avatar size="small" name="" />
    </Flex>

    <Division className="msg-bubble ms-2">
      <Flex className="msg-info">
        <Flex className="msg-info-name">
          <Skeleton height={10} width={200} animation="wave" variant="rounded" />
        </Flex>
        <Flex className="msg-info-time">
          <Skeleton height={10} width={60} animation="wave" variant="rounded" />
        </Flex>
      </Flex>
      <Flex direction="column" align={side === "left" ? "start" : "end"} justifyContent="start" className="mt-2">
        <Skeleton height={10} width={280} animation="wave" variant="rounded" />
        <Skeleton height={10} width={150} animation="wave" variant="rounded" className="mt-2" />
      </Flex>
    </Division>
  </Flex>
);

const InternalConversationLoading = () => {
  const placeholders = Array.from({ length: 1 });

  return (
    <>
      {placeholders.map((_, index) => (
        <React.Fragment key={`message-skeleton-${index+1}`}>
          <MessageSkeleton side="left" className="ms-2" />
          <MessageSkeleton side="right" />
          <MessageSkeleton side="left" className="ms-2" />
        </React.Fragment>
      ))}
    </>
  );
};

export default InternalConversationLoading;
